import { Skeleton } from "@/components/ui/skeleton";

export function AddCardToBinderQuantityInputSkeleton() {
  return (
    <div className="flex items-center gap-2">
      <Skeleton className="h-14 w-14 rounded-md" />
      <Skeleton className="h-14 w-14 rounded-md" />
      <Skeleton className="h-14 w-14 rounded-md" />
    </div>
  );
}
